import { P2PSignaling } from "./P2PSignaling";
import './communication/chat/Chat';
import './communication/chat/ChatEntry';
import './communication/video/VideoPanel';
import { Codellaborate } from './communication/codellaborate/Codellaborate';
document.addEventListener('DOMContentLoaded', Codellaborate.init);
// document.addEventLifefdsfdsfdsstener('DOMContentLoaded', function () {
//     // // 🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥
//     // // The Firebase SDK is initialized and available here!
//     //
//     firebase.auth().onAuthStateChanged(user => {
//         console.log(user)
//     });
//     firebase.database().ref('/stuff').on('value', snapshot => {
//         console.log(snapshot)
//     });
//     firebase.messaging().requestPermission().then(() => {
//     });
//     firebase.storage().ref('/path/to/ref').getDownloadURL().then(() => {
//     });
//     //
//     // // 🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥
//
try {
    // @ts-ignore
    let app = firebase.app();
    // let features = ['auth', 'database', 'messaging', 'storage'].filter(feature => typeof app[feature] === 'function');
    // document.getElementById('load').innerHTML = `Firebase SDK loaded with ${features.join(', ')}`;
    console.log(app);
    let url = new URL(window.location.href);
    console.log('stuff is happening', url);
    new P2PSignaling(Math.random() + '', !!url.searchParams.get(`initiator`));
}
catch (e) {
    console.error(e);
    // document.getElementById('load').innerHTML = 'Error loading the Firebase SDK, check the console.';
}
// });
